// Static data for the Contact component
import {
  FiMapPin,
  FiMail,
  FiPhone,
  FiClock,
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMap,
  FiMessageCircle,
  FiShield,
  FiAward,
  FiClock as FiClockAlt,
} from 'react-icons/fi';

export const CONTACT_CONTENT = {
  heading: "Let's Plan Vietnam, Together",
  subheading: 'Tell us about your vision, and we will build the perfect itinerary for your clients.',
  image:
    'https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=1400&auto=format&fit=crop',
};

export const CONTACT_DETAILS = [
  {
    icon: FiMapPin,
    label: 'Address',
    value: '12 Le Duan Street, District 1, Ho Chi Minh City, Vietnam',
  },
  { icon: FiMail, label: 'Email', value: 'partners@indochinedmc.com' },
  { icon: FiPhone, label: 'Phone', value: '+84 28 3822 1190' },
  { icon: FiClock, label: 'Office Hours', value: 'Mon – Sat, 9:00 AM – 6:30 PM (ICT)' },
];

export const SOCIAL_LINKS = [
  { icon: FiFacebook, label: 'Facebook', path: '#' },
  { icon: FiInstagram, label: 'Instagram', path: '#' },
  { icon: FiLinkedin, label: 'LinkedIn', path: '#' },
];

export const FORM_FIELDS = [
  { id: 'fullName', label: 'Full Name', type: 'text', required: true },
  { id: 'email', label: 'Email Address', type: 'email', required: true },
  { id: 'phone', label: 'Phone Number', type: 'tel', required: true },
  { id: 'company', label: 'Company (Optional)', type: 'text', required: false },
];

export const TRUST_BADGES = [
  { icon: FiShield, text: '24/7 Support' },
  { icon: FiAward, text: '10+ Years Experience' },
  { icon: FiClockAlt, text: 'Response Within 24 Hours' },
];

export const FAQ_ITEMS = [
  {
    id: 'faq-1',
    question: 'How quickly can you build an itinerary?',
    answer:
      'Most custom itineraries are ready within 48 hours. During peak season it may take up to 72 hours — we will keep you informed every step of the way.',
  },
  {
    id: 'faq-2',
    question: 'Do you work with last-minute requests?',
    answer:
      'Yes. Our ground team in Vietnam can turn around urgent requests in as little as 24 hours, including permits, guides, and accommodation.',
  },
  {
    id: 'faq-3',
    question: 'What destinations do you cover?',
    answer:
      'We cover all major regions of Vietnam — from Ha Long Bay and Hanoi in the north to Hoi An, Ho Chi Minh City, and the Mekong Delta in the south.',
  },
];

export const WHATSAPP_LINK = 'https://wa.me/842838221190';
export const CONSULTATION_LINK = '#';
export const MAPS_LINK = 'https://maps.google.com/?q=12+Le+Duan+Street+District+1+Ho+Chi+Minh+City';
